import { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";

import { convertToLocal } from "../utilities/Time";
import * as PortalHandler from "../utilities/RomePortal";

import Loading from "./Loading";
import Error from "./Error";
import Button from "./Button";

import "../css/TicketModerations.css";
import "../css/TicketInfo.css";

const DiscordList = ({moderations, setModerations}) => {
    const [editor, setEditor] = useState();

    const [isDelLoading, setIsDelLoading] = useState(false);

    const deleteModeration = () => {
        if (!editor) return;

        Swal.fire({
            title: "Are you sure?",
            text: "This action can't directly be reverted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c940",
            cancelButtonColor: "#c93434",
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsDelLoading(true)

                var deleteBanResponse = await PortalHandler.invoke("deleteDiscordModeration", {moderationID: editor.moderationID});
                if (deleteBanResponse.message == "Success") {
                    Swal.fire({
                        title: "Success",
                        text: "You have deleted this Discord moderation.",
                        icon: "success",
                        confirmButtonText: "Ok"
                    });

                    setModerations((old) => {
                        for (var i = 0; i < old.length; i++) {
                            if (old[i].moderationID == editor.moderationID) {
                                old.splice(i, 1);
                            }
                        }
                        return [...old];
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "There was an issue deleting this Discord moderation, it may no longer exist.",
                        icon: "error",
                        confirmButtonText: "Ok"
                    });
                }

                setIsDelLoading(false)
                setEditor()
            }
        });
    }

    return <>
        {!editor && <div className="ticket-moderations-list">
            {moderations.map((moderation) => {
                return <div onClick={() => setEditor(moderation)} className="ticket-moderations-list-item">
                    <div className="ticket-moderations-list-item-grouping">
                        <div className="ticket-moderations-list-item-row">
                            <span className="ticket-moderations-list-item-grouping-title"><i style={{color: "#c93434"}} class="fa-solid fa-id-card"></i> ID</span>
                            <i style={{marginLeft: "auto", fontSize: "1.25em"}} className="fa-solid fa-square-plus"></i>
                        </div>
                        <span className="ticket-moderations-list-item-grouping-value">{moderation.moderationID}</span>
                    </div>

                    <div className="ticket-moderations-list-item-grouping">
                        <span style={{color: "#ee8449"}} className="ticket-moderations-list-item-grouping-title"><i style={{color: "#ee8449"}} class="fa-solid fa-circle-question"></i> Type</span>
                        <span className="ticket-moderations-list-item-grouping-value">{moderation.moderationType}</span>
                    </div>
                    
                    <div className="ticket-moderations-list-item-grouping">
                        <span style={{color: "#349fc9"}} className="ticket-moderations-list-item-grouping-title"><i style={{color: "#349fc9"}} class="fa-solid fa-circle-question"></i> Reason</span>
                        <span className="ticket-moderations-list-item-grouping-value">{moderation.reason}</span>
                    </div>
                </div>
            })}
        </div>}

        {editor && <div className="ticket-moderations-editor">
            <div className="ticket-info-column">
                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-id-card"></i> ID</h4>
                    <h4>{editor.moderationID}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-flag"></i> Type</h4>
                    <h4>{editor.moderationType}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-regular fa-calendar-xmark"></i> Date</h4>
                    <h4>{convertToLocal(editor.moderatedOn)}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-certificate"></i> Moderator</h4>
                    <h4>{editor.moderator}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-circle-question"></i> Reason</h4>
                    <h4 className="ticket-moderations-field-body">{editor.reason}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-clipboard-list"></i> Evidence</h4>
                    <h4 className="ticket-moderations-field-body">{
                        editor.evidence.map((url, i) => {
                            return <>
                                <a target="_blank" href={url}>{url}</a>
                                {(i + 1) != editor.evidence.length && <span>, </span>}
                            </>
                        })
                    }{editor.evidence.length == 0 && <span>Nothing to see here...</span>}</h4>
                </div>

                <div className="ticket-moderations-list-item-row">
                    <Button
                        style={{width: "100%", marginTop: "5px"}}
                        data-size={1.2}
                        data-animation="raise"
                        data-style="cancel"

                        loading={isDelLoading}

                        onClick={deleteModeration}
                    >
                        <i className="fa-solid fa-trash"></i> Delete
                    </Button>

                    <Button
                        style={{width: "100%", marginTop: "5px"}}
                        data-size={1.2}
                        data-animation="raise"
                        data-style="info"

                        onClick={() => setEditor()}
                    >
                        <i className="fa-solid fa-rotate-left"></i> Back
                    </Button>
                </div>
            </div>
        </div>}
    </>
}

const RbxList = ({warnings, setWarnings}) => {
    const [editor, setEditor] = useState();

    const [isDelLoading, setIsDelLoading] = useState(false);

    const deleteWarning = () => {
        if (!editor) return;

        Swal.fire({
            title: "Are you sure?",
            text: "This action can't directly be reverted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c940",
            cancelButtonColor: "#c93434",
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsDelLoading(true)

                var deleteBanResponse = await PortalHandler.invoke("deleteRobloxWarning", {rbxID: editor.rbxID, warnID: editor.warnID});
                if (deleteBanResponse.message == "Success") {
                    Swal.fire({
                        title: "Success",
                        text: "You have deleted this Roblox warning.",
                        icon: "success",
                        confirmButtonText: "Ok"
                    });

                    setWarnings((old) => {
                        for (var i = 0; i < old.length; i++) {
                            if (old[i].warnID == editor.warnID) {
                                old.splice(i, 1);
                            }
                        }
                        return [...old];
                    });
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "There was an issue deleting this Roblox warning, it may no longer exist.",
                        icon: "error",
                        confirmButtonText: "Ok"
                    });
                }

                setIsDelLoading(false)
                setEditor()
            }
        });
    }

    return <>
        {!editor && <div className="ticket-moderations-list">
            {warnings.map((warning) => {
                return <div onClick={() => setEditor(warning)} className="ticket-moderations-list-item">
                    <div className="ticket-moderations-list-item-grouping">
                        <div className="ticket-moderations-list-item-row">
                            <span className="ticket-moderations-list-item-grouping-title"><i style={{color: "#c93434"}} class="fa-solid fa-id-card"></i> ID</span>
                            <i style={{marginLeft: "auto", fontSize: "1.25em"}} className="fa-solid fa-square-plus"></i>
                        </div>
                        <span className="ticket-moderations-list-item-grouping-value">{warning.warnID}</span>
                    </div>
                    
                    <div className="ticket-moderations-list-item-grouping">
                        <span style={{color: "#349fc9"}} className="ticket-moderations-list-item-grouping-title"><i style={{color: "#349fc9"}} class="fa-solid fa-circle-question"></i> Reason</span>
                        <span className="ticket-moderations-list-item-grouping-value">{warning.reason}</span>
                    </div>
                </div>
            })}
        </div>}

        {editor && <div className="ticket-moderations-editor">
            <div className="ticket-info-column">
                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-id-card"></i> ID</h4>
                    <h4>{editor.warnID}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-regular fa-calendar-xmark"></i> Date</h4>
                    <h4>{convertToLocal(editor.warnedOn)}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-certificate"></i> Moderator</h4>
                    <h4>{editor.moderator}</h4>
                </div>
                
                <div className="ticket-moderations-field">
                    <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-thumbs-up"></i> Acknowledged</h4>
                    <h4>{editor.acknowledged == 0 && <span style={{color: "#c93434"}}>No</span> || <span style={{color: "#34c940"}}>Yes</span>}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-circle-question"></i> Reason</h4>
                    <h4 className="ticket-moderations-field-body">{editor.reason}</h4>
                </div>

                <div className="ticket-moderations-field">
                    <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-clipboard-list"></i> Evidence</h4>
                    <h4 className="ticket-moderations-field-body">{
                        editor.evidence.map((url, i) => {
                            return <>
                                <a target="_blank" href={url}>{url}</a>
                                {(i + 1) != editor.evidence.length && <span>, </span>}
                            </>
                        })
                    }{editor.evidence.length == 0 && <span>Nothing to see here...</span>}</h4>
                </div>

                <div className="ticket-moderations-list-item-row">
                    <Button
                        style={{width: "100%", marginTop: "5px"}}
                        data-size={1.2}
                        data-animation="raise"
                        data-style="cancel"

                        loading={isDelLoading}

                        onClick={deleteWarning}
                    >
                        <i className="fa-solid fa-trash"></i> Delete
                    </Button>

                    <Button
                        style={{width: "100%", marginTop: "5px"}}
                        data-size={1.2}
                        data-animation="raise"
                        data-style="info"

                        onClick={() => setEditor()}
                    >
                        <i className="fa-solid fa-rotate-left"></i> Back
                    </Button>
                </div>
            </div>
        </div>}
    </>
}

const TicketModerations = ({ticketData}) => {
    const [status, setStatus] = useState("loading");
    const [page, setPage] = useState("roblox");

    const [isDelBanLoading, setIsDelBanLoading] = useState(false);

    const [rbxBan, setRbxBan] = useState()
    const [rbxWarnings, setRbxWarnings] = useState()

    const [discordBan, setDiscordBan] = useState()
    const [discordModerations, setDiscordModerations] = useState([])

    const deleteDiscordBan = () => {
        if (!discordBan) return;

        Swal.fire({
            title: "Are you sure?",
            text: "This action can't directly be reverted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c940",
            cancelButtonColor: "#c93434",
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsDelBanLoading(true)

                var deleteBanResponse = await PortalHandler.invoke("deleteDiscordBan", {discordID: ticketData.account.discordid});
                if (deleteBanResponse.message == "Success") {
                    Swal.fire({
                        title: "Success",
                        text: "You have deleted this Discord ban.",
                        icon: "success",
                        confirmButtonText: "Ok"
                    });
                    setDiscordBan(undefined)
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "There was an issue deleting this Discord ban, it may no longer exist.",
                        icon: "error",
                        confirmButtonText: "Ok"
                    });
                }

                setIsDelBanLoading(false)
            }
        });
    }

    const deleteBan = () => {
        if (!rbxBan) return;

        Swal.fire({
            title: "Are you sure?",
            text: "This action can't directly be reverted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c940",
            cancelButtonColor: "#c93434",
            confirmButtonText: "Confirm"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsDelBanLoading(true)

                var deleteBanResponse = await PortalHandler.invoke("deleteRobloxBan", {rbxID: ticketData.account.rbxid});
                if (deleteBanResponse.message == "Success") {
                    Swal.fire({
                        title: "Success",
                        text: "You have deleted this Roblox ban.",
                        icon: "success",
                        confirmButtonText: "Ok"
                    });
                    setRbxBan(undefined)
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "There was an issue deleting this Roblox ban, it may no longer exist.",
                        icon: "error",
                        confirmButtonText: "Ok"
                    });
                }

                setIsDelBanLoading(false)
            }
        });
    }

    useEffect(() => {
        (async () => {
            var rbxModProfileResponse = await PortalHandler.invoke("getRobloxModerationProfile", ticketData.account.rbxid);
            if (rbxModProfileResponse.message == "Success") {
                setRbxBan(rbxModProfileResponse.data.ban);
                setRbxWarnings(rbxModProfileResponse.data.warnings);
            }

            var discordModerationsResponse = await PortalHandler.invoke("getUserDiscordModerations", {discordid: ticketData.account.discordid});
            if (discordModerationsResponse.message == "Success") {
                setDiscordModerations(discordModerationsResponse.data);
            }

            var discordBanResponse = await PortalHandler.invoke("searchDiscordBan", ticketData.account.discordid);
            if (discordBanResponse.message == "Success") {
                setDiscordBan(discordBanResponse.data);
            }

            if (rbxModProfileResponse.message != "Success" || discordModerationsResponse.message == "Error" || discordBanResponse.message == "Error") {
                return setStatus("error");
            }

            setStatus("loaded");
        })();
    }, []);

    return <>
        <h3 className="ticket-info-page-alone-header">Moderation</h3>

        <Loading visible={status == "loading"} noBackground={true} text="Loading Moderations"/>
        <Error visible={status == "error"} noBackground={true} text="There was an issue loading this user's moderations, contact the Network Engineer."></Error>

        <div className="ticket-moderations-page-btns">
            <Button 
                data-status={page == "roblox" ? "selected" : "unselected"} 
                data-selectedcolor="red"
                data-type="basic"

                onClick={() => setPage("roblox")}
            >
                <i class="fa-solid fa-shapes"></i> Roblox
            </Button>
            
            <Button 
                data-status={page == "discord" ? "selected" : "unselected"} 
                data-selectedcolor="blue"
                data-type="basic"

                onClick={() => setPage("discord")}
            >
                <i className="fa-brands fa-discord"></i> Discord  
            </Button>
        </div>

        {status == "loaded" && <>
            {page == "roblox" && <div className="ticket-moderations-page">
                <div className="ticket-info-column">
                    <h3>Ban</h3>
                    {!rbxBan && <h4><i className="fa-solid fa-triangle-exclamation"></i> This user is not banned...</h4>}

                    {rbxBan && <>
                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-regular fa-calendar-xmark"></i> Date</h4>
                            <h4>{convertToLocal(rbxBan.bannedOn)}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-flag"></i> Type</h4>
                            <h4>{rbxBan.banType.Type}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-certificate"></i> Moderator</h4>
                            <h4>{rbxBan.moderator}</h4>
                        </div>

                        {rbxBan.banType.Type != "Permanent" && <div className="ticket-moderations-field">
                            <h4 style={{color: "#c93434"}} className="ticket-moderations-field-title"><i style={{color: "#c93434"}} class="fa-solid fa-stopwatch"></i> Unban Timestamp</h4>
                            <h4>{convertToLocal(rbxBan.bannedOn + rbxBan.banType.Time, true)}</h4>
                        </div>}

                        <div className="ticket-moderations-field">
                            <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-circle-question"></i> Reason</h4>
                            <h4 className="ticket-moderations-field-body">{rbxBan.reason}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-clipboard-list"></i> Evidence</h4>
                            <h4 className="ticket-moderations-field-body">{
                                rbxBan.evidence.map((url, i) => {
                                    return <>
                                        <a target="_blank" href={url}>{url}</a>
                                        {(i + 1) != rbxBan.evidence.length && <span>, </span>}
                                    </>
                                })
                            }{rbxBan.evidence.length == 0 && <span>Nothing to see here...</span>}</h4>
                        </div>

                        <Button
                            style={{width: "100%", marginTop: "5px"}}
                            data-size={1.2}
                            data-animation="raise"
                            data-style="cancel"

                            loading={isDelBanLoading}

                            onClick={deleteBan}
                        >
                            <i className="fa-solid fa-trash"></i> Delete
                        </Button>
                    </>}
                </div>

                <div className="ticket-info-column">
                    <h3>Warnings</h3>
                    {rbxWarnings.length == 0 && <h4><i className="fa-solid fa-triangle-exclamation"></i> This user has no warnings...</h4>}

                    {rbxWarnings.length > 0 && <RbxList
                        warnings={rbxWarnings}
                        setWarnings={setRbxWarnings}
                    />}
                </div>
            </div>}

            {page == "discord" && <div className="ticket-moderations-page">
                <div className="ticket-info-column">
                    <h3>Ban</h3>
                    {!discordBan && <h4><i className="fa-solid fa-triangle-exclamation"></i> This user is not banned...</h4>}

                    {discordBan && <>
                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-regular fa-calendar-xmark"></i> Date</h4>
                            <h4>{convertToLocal(discordBan.bannedOn)}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-flag"></i> Type</h4>
                            <h4>{discordBan.banType.Type}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 className="ticket-moderations-field-title"><i class="fa-solid fa-certificate"></i> Moderator</h4>
                            <h4>{discordBan.moderator}</h4>
                        </div>

                        {discordBan.banType.Type != "Permanent" && <div className="ticket-moderations-field">
                            <h4 style={{color: "#c93434"}} className="ticket-moderations-field-title"><i style={{color: "#c93434"}} class="fa-solid fa-stopwatch"></i> Unban Timestamp</h4>
                            <h4>{convertToLocal(discordBan.bannedOn + discordBan.banType.Time, true)}</h4>
                        </div>}

                        <div className="ticket-moderations-field">
                            <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-circle-question"></i> Reason</h4>
                            <h4 className="ticket-moderations-field-body">{discordBan.reason}</h4>
                        </div>

                        <div className="ticket-moderations-field">
                            <h4 style={{color: "#ee8449"}} className="ticket-moderations-field-title"><i style={{color: "#ee8449"}} class="fa-solid fa-clipboard-list"></i> Evidence</h4>
                            <h4 className="ticket-moderations-field-body">{
                                discordBan.evidence.map((url, i) => {
                                    return <>
                                        <a target="_blank" href={url}>{url}</a>
                                        {(i + 1) != discordBan.evidence.length && <span>, </span>}
                                    </>
                                })
                            }{discordBan.evidence.length == 0 && <span>Nothing to see here...</span>}</h4>
                        </div>

                        <Button
                            style={{width: "100%", marginTop: "5px"}}
                            data-size={1.2}
                            data-animation="raise"
                            data-style="cancel"

                            loading={isDelBanLoading}

                            onClick={deleteDiscordBan}
                        >
                            <i className="fa-solid fa-trash"></i> Delete
                        </Button>
                    </>}
                </div>

                <div className="ticket-info-column">
                    <h3>Moderations</h3>
                    {discordModerations.length == 0 && <h4><i className="fa-solid fa-triangle-exclamation"></i> This user has no moderations...</h4>}

                    {discordModerations.length > 0 && <DiscordList
                        moderations={discordModerations}
                        setModerations={setDiscordModerations}
                    />}
                </div>
            </div>}
        </>}
    </>
}

export default TicketModerations;